<template>
  <div class="reimbursementPage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode!='add'"
          readonly
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          class="ggInput"
          input-align="right"
          v-else
          readonly
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applyName"
          class="ggInput"
          input-align="right"
          clearable
          :required="editType"
          :readonly="!editType"
          label="标题："
          :placeholder="editType?'请输入...  ':''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="applyTypeName"
          class="ggInput"
          input-align="right"
          clearable
          :required="editType"
          readonly
          label="申请类型："
          :is-link="editType"
          @click="changeOtherType"
          :placeholder="editType?'请选择':''"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          class="ggInput"
          input-align="right"
          clearable
          rows="1"
          :readonly="!editType"
          autosize
          type="textarea"
          :required="editType"
          label="用途："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <!-- 审批流程 -->
      <div class="approveList" v-if="this.mode != 'add' && propertyData.verifyStatus!='hold'">
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div class="flowList" v-if="this.mode != 'add' && propertyData.verifyStatus!='hold'">
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main :applicantData="propertyData" @changeVerifyType="setVerifyType"></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode=='add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
      >提交</van-button>
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div class="btnBox editBtnbox clearfix" v-if="propertyData.verifyStatus=='hold'">
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
            >删除</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
            >保存</van-button>
          </van-col>
        </van-row>
      </div>
      <div class="btnBox denyBtn clearfix" v-if="propertyData.verifyStatus=='deny'">
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
        >再次提交</van-button>
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="propertyData.verifyStatus=='pending' && mode != 'verify' && sendType!='1'"
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
      >撤回修改</van-button>
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="(mode=='verify' && propertyData.verifyStatus=='pending'  &&  verifyType == '1') ||(mode=='verify' && propertyData.verifyStatus=='doing'  &&  verifyType == '1') "
    >
      <van-button type="info" @click="verifyPage">{{verifyPageText}}</van-button>
    </div>
    <!-- 弹出框 -->
    <!--  -->
    <!-- 资金用途 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        value-key="dictName"
        @cancel="showTypePicker = false"
        @confirm="saveType"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { isEdit,getDictList } from "@/utils/common";
import { getDeviceType, closePage,is_wei } from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
export default {
  name: "otherCapital",
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      addType: false, //防止高频点击
      propertyData: {
        applicantIdName: "",
        reason: "", //申请原因
        applyName: "", //申请名称
        applyType: "", //申请类型
        verifyStatus: "hold"
      },
      applyTypeName:"",
      showTypePicker: false,
      typeColumns: [], //其他类型申请
      clientType: getDeviceType(),
       sendType:"",//判断是否在抄送列表
    };
  },
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff
  },
  mounted() {
       if(is_wei()){
      document.title="其他申请";
    }
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.sendType =  this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面
    window.verifyPage = this.verifyPage; //审批页面
    this.getTypeList();
    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify"|| this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    //选择类型
    changeOtherType() {
      let _this = this;
      if (this.editType) {
        this.showTypePicker = true;
      }
    },
    async getTypeList() {
      this.typeColumns = await getDictList("qita"); //字典项接口获取资金用途
    },
      saveType(data) {
      this.showTypePicker = false;
      this.applyTypeName = data.dictName;
      this.$set(this.propertyData, "applyType", data.dictCode);
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = _this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?"
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.applyOthers
            .deleteRecall(
              _this.propertyData.verifyStatus,
              _this.propertyData.id
            )
            .then(res => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(err => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
     //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.finance.applyOthers
        .detail(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            this.applyTypeName = res.data.applyTypeName;
            let type = isEdit(_this.propertyData.verifyStatus, _this.mode);
            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        let params = this.propertyData;
        _this.btnLoading = true;
        _this.$api.finance.applyOthers
          .update(this.mode, params)
          .then(res => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch(err => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    validate() {
      let _this = this;
      if (this.propertyData.applyName == "" || this.propertyData.reason == "") {
        _this.$toast("请完善表单信息");
        return false;
      }
      return true;
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.reimbursementPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>